<template>
    <component
            :is="type"
            :plugins="plugins"
            :content="content"
            v-bind="$attrs"/>
</template>

<script>
    import cmsPluginMixin from 'framework/mixins/cms/cms-plugin';

    export default {
        mixins: [cmsPluginMixin],
        props: {
            type: {
                type: String,
                required: true,
            },
        },
    };
</script>
